import { getByType } from 'utils/stuff.js'
import { leases, properties, tenants } from './entities'
import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { makePropSelector, makeDocSelector, currentDate } from './common'
import { getTimezoneDate } from 'utils/date'
import { termsByLeaseID } from './index'


let attachments = state => state.attachments

// export let termsByLeaseID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('parentID'))))
export let leaseByTenantID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('tenantID'))))
export let leaseByPropertyID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('propertyID'))))
export let objectTerms = createSelector([termsByLeaseID, makePropSelector('objectID'), leases, makeDocSelector('objectID')], (termsByLeaseID, objectID, leases, lease) =>{
	let parentID = lease && lease.parentID || objectID
	let mainLease = lease && lease.parentID && leases[lease.parentID] || lease
	let terms = termsByLeaseID[parentID] || []

	terms = R.filter(x=>{
		if (x.parentID) return true
		return false
	})(terms)
	// terms = R.map(x=>{
	// 	if (x._id==parentID){
	// 		console.log(x._id);
	// 		return {...x, main:true}
	// 	}else return x
	// })(terms)
	terms.push({...mainLease, main: true})
	let extend = term => {
		return{
			...term
		  , date:getTimezoneDate(term.dateTill)
		}
	}
	return R.pipe(R.map(extend), R.sortBy(R.prop('date')))(terms)
})

export let termsByPropertyID = createSelector([leaseByPropertyID, makePropSelector('propertyID'), leases], (leaseByPropertyID, objectID, leases) =>{
	let terms = [...(leaseByPropertyID[objectID])|| []] || []
	return R.pipe(R.sortBy(R.prop('dateTill')))(terms)
})
export let termsByTenantID = createSelector([termsByLeaseID, makePropSelector('objectID'), leases, tenants,leaseByTenantID], (termsByLeaseID, objectID, leases, tenants,leaseByTenantID) =>{
	let tenant=tenants[objectID]
	let tenantID = tenant && (tenant.tenantID || tenant._id)
	let lease = leaseByTenantID[tenantID] && leaseByTenantID[tenantID][0]
	let leaseID = lease && (lease.parentID || lease._id)
	let terms = leaseID && [...(termsByLeaseID[leaseID])|| []] || []
	terms.push({...leases[leaseID], main: true})
	let extend = term => {
		return{
			...term
		  , date:getTimezoneDate(term.dateFrom)
		}
	}
	return R.pipe(R.map(extend), R.sortBy(R.prop('date')))(terms)
})

export let leaseFilter = createSelector(
	[leases, termsByLeaseID, currentDate],
	(leases, termsByLeaseID, currentDate) =>{
		let ex= lease =>{
			if (lease.breakDateTill){
				if (getTimezoneDate(lease.breakDateTill)>=getTimezoneDate(currentDate)){
					return {...lease, active:true}
				}
				return {...lease, active:false}
			}
			let terms=termsByLeaseID[lease._id] || []
			terms.push(lease)
			for(let i=0;i<terms.length;i++){
				if (getTimezoneDate(terms[i].dateFrom)<=getTimezoneDate(currentDate)&&getTimezoneDate(terms[i].dateTill)>=getTimezoneDate(currentDate)){
					return {...lease, active:true}
				}
			}
			return {...lease, active:false}
		}
		return R.map(ex)(leases)
	}
)

export default (state) => (id) => {
	let lease = leases(state)[id]
	if(!lease) return undefined
	return ({
		...lease
	  , property: properties(state)[lease.property]
	  , tenant: (lease.tenantID)? tenants(state)[lease.tenantID] : undefined
	  , tenants:
			(lease.tenantsIDs !== undefined)?
				R.filter(tenant =>
					!!~lease.tenantsIDs.indexOf(tenant._id), tenants(state))
			: []
	  , comments: (lease.comments)?R.map(
			commentData =>({
				...commentData
			  , attachments: (commentData.attachmentsIDs)?R.map(
					attachmentID =>
						(attachments(state)[lease._id]
						&& attachments(state)[lease._id].attachments[attachmentID.id])?
							attachments(state)[lease._id].attachments[attachmentID.id]
							: false
					, commentData.attachmentsIDs
				)
				: {}
			})
			, lease.comments)
			: []
	})
}



// WEBPACK FOOTER //
// ./src/selectors/lease.js